import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { PercentageIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/configuration-management/discount-management/$discountCategory')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="configurationManagement.discountManagement.slab.page.crumb" icon={PercentageIcon} />,
      title: <Translation id="configurationManagement.discountManagement.slab.page.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
